// @flow

type ModuleWithDefaultExport = { default: () => void, ... };

const actionEntryPoints: {
  [actionName: string]: void | (() => Promise<ModuleWithDefaultExport>),
  ...
} = {
  landingPagesShow: () => import('./actionSpecificSetup/landingPagesShow'),
  listsShow: () => import('./actionSpecificSetup/listsShow'),
  priceRequestsNew: () => import('./actionSpecificSetup/priceRequestsNew'),
  reviewsEdit: () => import('./actionSpecificSetup/reviewsEdit'),
  reviewsNew: () => import('./actionSpecificSetup/reviewsNew'),
  'catering/reviewsNew': () => import('./actionSpecificSetup/reviewsNew'),
  venuesShow: () => import('./actionSpecificSetup/venuesShow'),

  'catering/admin/profilesEdit': () =>
    import('./actionSpecificSetup/catering/admin/profilesEdit'),
  'catering/admin/menusIndex': () =>
    import('./actionSpecificSetup/catering/admin/menusIndex'),

  'admin/archives': () => import('./actionSpecificSetup/admin/archives'),
  'admin/venuesEdit': () => import('./actionSpecificSetup/admin/venuesEdit'),
  'admin/venuesIndex': () => import('./actionSpecificSetup/admin/venuesIndex'),

  'search/venuesIndex': () =>
    import('./actionSpecificSetup/search/venuesIndex'),

  'staff/imagesIndex': () => import('./actionSpecificSetup/staff/imagesIndex'),
  'staff/prospectsIndex': () =>
    import('./actionSpecificSetup/staff/prospectsIndex'),
  'staff/organizationsEdit': () =>
    import('./actionSpecificSetup/staff/organizationsEdit'),

  'users/registrationsEdit': () =>
    import('./actionSpecificSetup/users/registrationsEdit')
};

export default actionEntryPoints;
